<template lang="pug">
  .bg-gray-100.min-h-screen
    
    div.p-2(v-if="isMovil")
      div.contenedor-transition-box(
        name="slide-up" 
        is="transition-group"
        v-show='lista.length !== 0', 
        v-infinite-scroll="fetchByScroll" 
        infinite-scroll-disabled="disabledScrollExecute" 
        infinite-scroll-distance="2"
      )
        .mb-2(
          v-for="(item, index) in lista"
          :key="index"
          @click="item.showFull = !item.showFull"
        )
          .flex.justify-center.mb-2(v-if="index === 0 || item.fechaString !== lista[index - 1].fechaString")
            span.text-xxs.rounded-full.px-3.bg-primary.text-white.p-1.rounded.leading-none {{ item.fecha | formatDateDay}}
          .p-5.bg-white.rounded-lg.shadow-xs.relative
            .absolute.top-0.left-0.mt-1.ml-1
              .text-gray-500.text-xs {{ item.hora }}
            .absolute.top-0.right-0.mt-1.mr-1(@click.stop="irACirugia(item._id)")
              i.fas.fa-edit.text-gray-500
            span.text-sm.font-bold {{ item.descripcionTipoCirugia }}
            span.text-sm  con 
            span.text-sm.font-bold {{ item.nombreDoctor }}
            span.text-sm  en 
            span.text-sm.font-bold {{ item.descripcionClinica }}
            div(v-show="item.showFull")
              .flex.text-xs.mt-4
                .flex.flex-col.flex-1.items-center
                  i.fas.fa-user-cog.text-gray-500
                  span.font-bold.text-xxs {{ item.nombreTecnico}}
                .flex.flex-col.flex-1.items-center
                  i.fas.fa-user-nurse.text-gray-500
                  span.font-bold.text-xxs {{ item.nombreEnfermera}}
                .flex.flex-col.flex-1.items-center(v-if="item.montoCobrado > 0")
                  i.fas.fa-money-bill.text-gray-500
                  span.font-bold.text-xxs S/ {{ item.montoCobrado | twoDecimals}}
              .mt-3.text-xs.text-left.text-blue-600.bg-blue-200.border.border-blue-400.flex.items-center.p-3.rounded-sm(v-if="item.comentario") {{ item.comentario }}

    div(v-else)
      .filtros.flex.mt-2.justify-center.items-center
        .flex.flex-col.flex-1
          .flex
            .flex.mb-2.flex.p-2(key="doctor")
              .flex-1
                span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Doctor
                .relative
                  input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
                    v-model='nombreDoctor'
                    @keyup.down="showPopoverDoctor = true"
                    @keyup.up="showPopoverDoctor = true"
                    @keyup.space="showPopoverDoctor = true"
                    @click="showPopoverDoctor = true"
                    ref="doctor"
                    placeholder="No se han ingresado datos"
                  )
                  span.absolute.left-0.top-0.pt-2.pl-3
                    i.fas.fa-user-md.text-gray-500
                  
                  span.absolute.right-0.top-0.pt-2.pr-3(@click="showPopoverDoctor = true")
                    i.fas.fa-angle-down.text-gray-500
                  transition(name="slide-up")
                    u-popover(v-if="showPopoverDoctor", @close="showPopoverDoctor = false")
                      doctor-seleccionar(
                        @selected="seleccionarDoctor"
                        @close="cerrarDoctor"
                      )
            .flex.mb-2.p-2(key="clinica")
              .flex-1
                span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Clínica
                .relative
                  input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
                    v-model='descripcionClinica'
                    @keyup.down="showPopoverClinica = true"
                    @keyup.up="showPopoverClinica = true"
                    @keyup.space="showPopoverClinica = true"
                    @click="showPopoverClinica = true"
                    ref="clinica"
                    placeholder="No se han ingresado datos"
                  )
                  span.absolute.left-0.top-0.pt-2.pl-3
                    i.fas.fa-hospital.text-gray-500
                  
                  span.absolute.right-0.top-0.pt-2.pr-3(@click="showPopoverClinica = true")
                    i.fas.fa-angle-down.text-gray-500
                  transition(name="slide-up")
                    u-popover(v-if="showPopoverClinica", @close="showPopoverClinica = false")
                      clinica-seleccionar(
                        @selected="seleccionarClinica"
                        @close="cerrarClinica"
                      )

            .flex.mb-2.p-2(key="tipo-cirugia")
              .flex-1
                span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Tipo cirugía
                .relative
                  input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
                    v-model='descripcionTipoCirugia'
                    @keyup.down="showPopoverTipoCirugia = true"
                    @keyup.up="showPopoverTipoCirugia = true"
                    @keyup.space="showPopoverTipoCirugia = true"
                    @click="showPopoverTipoCirugia = true"
                    ref="tipoCirugia"
                    placeholder="No se han ingresado datos"
                  )
                  span.absolute.left-0.top-0.pt-2.pl-3
                    i.fas.fa-procedures.text-gray-500
                  
                  span.absolute.right-0.top-0.pt-2.pr-3(@click="showPopoverTipoCirugia = true")
                    i.fas.fa-angle-down.text-gray-500
                  transition(name="slide-up")
                    u-popover(v-if="showPopoverTipoCirugia", @close="showPopoverTipoCirugia = false")
                      tipo-cirugia-seleccionar(
                        @selected="seleccionarTipoCirugia"
                        @close="cerrarTipoCirugia"
                      )
            .flex.mb-2.p-2(key="tipo-cobro")
              .flex-1
                span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Tipo cobro
                
                .flex
                  .flex.flex-col.flex-1.cursor-pointer.justify-center.items-center.m-1.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.py-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm.transition.duration-300.ease-in-out(
                    @click="tipoCobro = tipoCobro === 'particular' ? '' : 'particular'; actualizar()"
                    :class="{'is-active': tipoCobro === 'particular'}"
                  )

                    i.fas.fa-money-bill.text-gray-500
                    span Particular
                  .flex.flex-col.flex-1.cursor-pointer.justify-center.items-center.m-1.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.py-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm.transition.duration-300.ease-in-out(
                    @click="tipoCobro = tipoCobro === 'credito' ? '' : 'credito'; actualizar()"
                    :class="{'is-active': tipoCobro === 'credito'}"
                  )
                    i.fas.fa-money-check.text-gray-500
                    span Crédito
                  .flex.flex-col.flex-1.cursor-pointer.justify-center.items-center.m-1.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.py-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm.transition.duration-300.ease-in-out(
                    @click="tipoCobro = tipoCobro === 'transferencia' ? '' : 'transferencia'; actualizar()"
                    :class="{'is-active': tipoCobro === 'transferencia'}"
                  )
                    i.fas.fa-money-check.text-gray-500
                    span Transferencia
          .flex             

            .flex.mb-2.p-2(key="tecnico")
              .flex-1
                span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Técnico
                .relative
                  input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
                    v-model='nombreTecnico'
                    @keyup.down="showPopoverTecnico = true"
                    @keyup.up="showPopoverTecnico = true"
                    @keyup.space="showPopoverTecnico = true"
                    @click="showPopoverTecnico = true"
                    ref="tecnico"
                    placeholder="No se han ingresado datos"
                    :disabled="perfil === 'tecnico'"
                  )
                  span.absolute.left-0.top-0.pt-2.pl-3
                    i.fas.fa-user-cog.text-gray-500
                  
                  span.absolute.right-0.top-0.pt-2.pr-3(@click="showPopoverTecnico = true", v-if="perfil !== 'tecnico'")
                    i.fas.fa-angle-down.text-gray-500
                  transition(name="slide-up")
                    u-popover(v-if="showPopoverTecnico", @close="showPopoverTecnico = false")
                      tecnico-seleccionar(
                        @selected="seleccionarTecnico"
                        @close="cerrarTecnico"
                      )

            .flex.mb-2.p-2(key="enfermera")
              .flex-1
                span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Enfermera
                .relative
                  input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
                    v-model='nombreEnfermera'
                    @keyup.down="showPopoverEnfermera = true"
                    @keyup.up="showPopoverEnfermera = true"
                    @keyup.space="showPopoverEnfermera = true"
                    @click="showPopoverEnfermera = true"
                    ref="enfermera"
                    placeholder="No se han ingresado datos"
                    :disabled="perfil === 'enfermera'"
                  )
                  span.absolute.left-0.top-0.pt-2.pl-3
                    i.fas.fa-user-nurse.text-gray-500
                  
                  span.absolute.right-0.top-0.pt-2.pr-3(@click="showPopoverEnfermera = true", v-if="perfil !== 'enfermera'")
                    i.fas.fa-angle-down.text-gray-500
                  transition(name="slide-up")
                    u-popover(v-if="showPopoverEnfermera", @close="showPopoverEnfermera = false")
                      enfermera-seleccionar(
                        @selected="seleccionarEnfermera"
                        @close="cerrarEnfermera"
                      )

            .flex.mb-2.p-2(key="fechaDesde")
              .flex-1
                span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Fecha desde
                .relative
                  input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
                    v-model='fechaDesde'
                    ref="fechaDesde"
                    type="date"
                  )
                  span.absolute.left-0.top-0.pt-2.pl-3
                    i.fas.fa-calendar.text-gray-500
            .flex.mb-2.p-2(key="fechaHasta")
              .flex-1
                span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Fecha hasta
                .relative
                  input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
                    v-model='fechaHasta'
                    ref="fechaHasta"
                    type="date"
                    placeholder="No se han ingresado datos"
                  )
                  span.absolute.left-0.top-0.pt-2.pl-3
                    i.fas.fa-calendar.text-gray-500

        .flex.mb-2.p-2.flex-col.text-xs(key="buttons")
          button.text-primary.border-primary.border.font-bold.py-1.px-2.rounded.cursor-pointer(@click="fetch") Refrescar
          button.mt-1.bg-primary.text-white.font-bold.py-1.px-2.rounded.cursor-pointer(@click="downloadExcel", :disabled="isLoadingExcel") Exportar excel

      table.w-full
        thead.sticky.top-0
          tr.sticky.top-0
            th.w-10.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('fecha')")
              .flex
                span Fecha
                span.pl-1(v-if="sortByName === 'fecha'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.w-10.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('hora')")
              .flex
                span Hora
                span.pl-1(v-if="sortByName === 'hora'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('nombreDoctor')") 
              .flex
                span Doctor
                span.pl-1(v-if="sortByName === 'nombreDoctor'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('descripcionClinica')") 
              .flex
                span Clínica
                span.pl-1(v-if="sortByName === 'descripcionClinica'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('descripcionTipoCirugia')") 
              .flex
                span Tipo Cirugía
                span.pl-1(v-if="sortByName === 'descripcionTipoCirugia'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('nombreTecnico')") 
              .flex
                span Técnico
                span.pl-1(v-if="sortByName === 'nombreTecnico'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('nombreEnfermera')") 
              .flex
                span Enfermera
                span.pl-1(v-if="sortByName === 'nombreEnfermera'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('tipoCobro')")
              .flex
                span Tipo cobro
                span.pl-1(v-if="sortByName === 'tipoCobro'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('montoCobrado')")
              .flex
                span Monto Cobrado
                span.pl-1(v-if="sortByName === 'montoCobrado'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('nombrePaciente')")
              .flex
                span Nombre Paciente
                span.pl-1(v-if="sortByName === 'nombrePaciente'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('clipsUtilizados')")
              .flex
                span Clips Utilizados
                span.pl-1(v-if="sortByName === 'clipsUtilizados'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('codigoMarcaGrapa')")
              .flex
                span Marca de grapas
                span.pl-1(v-if="sortByName === 'codigoMarcaGrapa'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('grapasUtilizadas')")
              .flex
                span Grapas Utilizadas
                span.pl-1(v-if="sortByName === 'grapasUtilizadas'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('numeroCaja')")
              .flex
                span Número de caja
                span.pl-1(v-if="sortByName === 'numeroCaja'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer
              .flex
                span Comentario
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('fechaCreacion')") 
              .flex
                span Fecha Creación
                span.pl-1(v-if="sortByName === 'fechaCreacion'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('fechaModificacion')") 
              .flex
                span Fecha Modificación
                span.pl-1(v-if="sortByName === 'fechaModificacion'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
            th.py-2.px-2.sticky.top-0.bg-gray-300.text-sm.font-medium.text-gray-600.cursor-pointer(@click="asignarSortBy('creadoPor')") 
              .flex
                span Creado por
                span.pl-1(v-if="sortByName === 'creadoPor'")
                  i.fas.fa-arrow-down(v-if="sortByType === 'desc'")
                  i.fas.fa-arrow-up(v-else)
        tbody.text-xs(
          name="slide-up" 
          is="transition-group"
          v-show='lista.length !== 0', 
          v-infinite-scroll="fetchByScroll" 
          infinite-scroll-disabled="disabledScrollExecute" 
          infinite-scroll-distance="2"
        )
          tr(v-for="(item, index) in lista" 
            class='hover:bg-gray-100'
            @dblclick='irACirugia(item._id)',
            @contextmenu.prevent="openMenu(item, index)",
            ref="task"
            :key="index + 1"
          )
            td.py-0.px-2.border-b.border-grey-light {{item.fechaString}}
            td.py-0.px-2.border-b.border-grey-light {{item.hora}}
            td.py-0.px-2.border-b.border-grey-light {{item.nombreDoctor}}
            td.py-0.px-2.border-b.border-grey-light {{item.descripcionClinica}}
            td.py-0.px-2.border-b.border-grey-light {{item.descripcionTipoCirugia}}
            td.py-0.px-2.border-b.border-grey-light {{item.nombreTecnico}}
            td.py-0.px-2.border-b.border-grey-light {{item.nombreEnfermera}}
            td.py-0.px-2.border-b.border-grey-light {{item.tipoCobro}}
            td.py-0.px-2.border-b.border-grey-light S/{{item.montoCobrado | twoDecimals}}
            td.py-0.px-2.border-b.border-grey-light {{item.nombrePaciente }}
            td.py-0.px-2.border-b.border-grey-light.text-center {{item.clipsUtilizados }}
            td.py-0.px-2.border-b.border-grey-light 
              span(v-if="item.descripcionMarcaGrapa") {{item.descripcionMarcaGrapa }}
            td.py-0.px-2.border-b.border-grey-light.text-center
              span(v-if="!item.grapasMoradas && !item.grapasNegras && !item.grapasDoradas") {{item.grapasUtilizadas }}
              span.p-1.ml-1.rounded-full.bg-purple-500.text-white(v-if="item.grapasMoradas") {{item.grapasMoradas }}
              span.p-1.ml-1.rounded-full.bg-black.text-white(v-if="item.grapasNegras") {{item.grapasNegras }}
              span.p-1.ml-1.rounded-full.bg-yellow-500(v-if="item.grapasDoradas") {{item.grapasDoradas }}
            td.py-0.px-2.border-b.border-grey-light.text-center {{item.numeroCaja }}
            td.py-0.px-2.border-b.border-grey-light {{item.comentario}}
            td.text-center.py-0.px-2.border-b.border-grey-light.text-gray-600
              .flex.flex-col
                span {{item.fechaCreacion | formatDateDay}}
                span.text-xxs {{item.fechaCreacion | formatDateHour}}
            td.text-center.py-0.px-2.border-b.border-grey-light.text-gray-600
              .flex.flex-col
                span {{item.fechaModificacion | formatDateDay}}
                span.text-xxs {{item.fechaModificacion | formatDateHour}}
            td.py-0.px-2.border-b.border-grey-light {{item.creadoPor }}
      
    .m-2.mt-3.text-xs.text-left.text-blue-600.bg-blue-200.border.border-blue-400.flex.items-center.p-3.rounded-sm(v-if="lista.length === 0 && !isLoading") No existe ninguna cirugía registrada.

    .is-loading.flex.items-center.justify-center.text-primary.text-xl(v-if="isLoading")
      i.fas.fa-spinner.fa-spin
    .fixed.bottom-0.right-0.padding-floating-button
      .flex.justify-center.items-center.p-0.w-10.h-10.bg-primary.rounded-full.mouse.shadow.text-white(@click="nuevaCirugia")
        i.fas.fa-plus
      
    

</template>

<script>
import { apiGet, notify, apiGetExcel } from '../util/general'
import Router from '../router/admin.js'
import Popover from '@/components/c_util_popover.vue'
import ClinicaSeleccionar from '@/components/c_clinica_seleccionar.vue'
import DoctorSeleccionar from '@/components/c_doctor_seleccionar.vue'
import TecnicoSeleccionar from '@/components/c_tecnico_seleccionar.vue'
import EnfermeraSeleccionar from '@/components/c_enfermera_seleccionar.vue'
import TipoCirugiaSeleccionar from '@/components/c_tipo_cirugia_seleccionar.vue'
export default {
  name: 'v_cirugia_list',
  components: {
    'u-popover'                : Popover,
    'clinica-seleccionar'      : ClinicaSeleccionar,
    'doctor-seleccionar'       : DoctorSeleccionar,
    'tecnico-seleccionar'      : TecnicoSeleccionar,
    'enfermera-seleccionar'    : EnfermeraSeleccionar,
    'tipo-cirugia-seleccionar' : TipoCirugiaSeleccionar
  },
  data () {
    return {
      perfil                 : localStorage.getItem('perfil'),
      nombreUsuarioLogueado  : localStorage.getItem('nombre'),
      idLogueado             : localStorage.getItem('_id'),
      isLoading              : false,
      isLoadingExcel         : false,
      skip                   : 0,
      disabledScrollExecute  : false,
      noMore                 : false,
      isScroll               : false,
      isExcel                : false,
      lista                  : [],
      isMovil                : false,
      window                 : { width : 0, height: 0 },
      minWidthMedia          : 800,
      sortByName             : 'fecha',
      sortByType             : 'desc',
      // input clinica
      showPopoverClinica     : false,
      idClinica              : '',
      descripcionClinica     : '',
      // input doctor
      showPopoverDoctor      : false,
      idDoctor               : '',
      nombreDoctor           : '',
      // input tecnico
      showPopoverTecnico     : false,
      idTecnico              : '',
      nombreTecnico          : '',
      // input enfermera
      showPopoverEnfermera   : false,
      idEnfermera            : '',
      nombreEnfermera        : '',
      // input tipo cirugia
      showPopoverTipoCirugia : false,
      idTipoCirugia          : '',
      descripcionTipoCirugia : '',
      // ,
      tipoCobro  : '',
      fechaDesde : '',
      fechaHasta : ''
    }
  },
  created () {
    var vm = this

    if (vm.perfil === 'tecnico') {
      vm.idTecnico     = vm.idLogueado
      vm.nombreTecnico = vm.nombreUsuarioLogueado
    }

    if (vm.perfil === 'enfermera') {
      vm.idEnfermera     = vm.idLogueado
      vm.nombreEnfermera = vm.nombreUsuarioLogueado
    }

    window.addEventListener('resize', vm.handleResize)
    vm.handleResize()
  },
  destroyed () {
    var vm = this
    window.removeEventListener('resize', vm.handleResize)
  },
  methods: {
    handleResize () {
      console.log('cambio tamaño de la pantalla.. ')
      var vm = this
      vm.window.width  = window.innerWidth;
      // vm.window.height = window.innerHeight;

      var isMovilPrev = vm.isMovil

      if (vm.window.width < vm.minWidthMedia) vm.isMovil = true
      // else if (vm.window.height < vm.minHeightMedia) vm.isMovil = true
      else vm.isMovil   = false

      if (isMovilPrev !== vm.isMovil) vm.fetch()
    },
    fetchByScroll () {
      this.isScroll = true
      this.fetch()
    },
    fetch () {
      var vm                    = this
      vm.disabledScrollExecute  = true
      vm.isLoading              = true
      vm.noMore                 = false

      if (!vm.isScroll) {
        vm.lista  = []
        vm.skip = 0
      }

      var url = '/cirugia'

      var obj = {}

      if (vm.isMovil) {
        obj.sortByName = 'fecha'
        obj.sortByType = 'desc'
      } else {
        obj.sortByName = vm.sortByName
        obj.sortByType = vm.sortByType
      }

      if (vm.skip) obj.skip = vm.skip

      obj.idClinica     = vm.idClinica
      obj.idDoctor      = vm.idDoctor
      obj.idTecnico     = vm.idTecnico
      obj.idEnfermera   = vm.idEnfermera
      obj.idTipoCirugia = vm.idTipoCirugia
      obj.tipoCobro     = vm.tipoCobro
      obj.fechaDesde    = vm.fechaDesde
      obj.fechaHasta    = vm.fechaHasta

      apiGet(vm, url, obj, function (data) {
        // console.log(data)
        for (var i = 0; i < data.lista.length; i++) {
          vm.lista.push(data.lista[i])
        }

        if (data.noMore) {
          vm.noMore                = true
          vm.disabledScrollExecute = true
        } else {
          vm.skip = data.newSkip
          vm.disabledScrollExecute = false
        }
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        vm.disabledScrollExecute = true
      }, function () {
        vm.isLoading = false
        vm.isExcel   = false
        vm.isScroll  = false
      })
    },
    irACirugia (_id) {
      // var vm = this
      Router.push('/cirugia/' + _id)
      // vm.$router.go()
    },
    nuevaCirugia (_id) {
      // var vm = this
      Router.push('/cirugia')
      // vm.$router.go()
    },
    asignarSortBy (campo) {
      var vm = this

      if (vm.sortByName === campo) {
        vm.sortByType = vm.sortByType === 'desc' ? 'asc' : 'desc'
      } else {
        vm.sortByName = campo
        vm.sortByType = 'desc'
      }
      vm.fetch()
    },
    // Popover clinica
    seleccionarClinica (o) {
      var vm            = this
      vm.idClinica      = o._id ? o._id + '' : ''
      vm.descripcionClinica = o.descripcion
      vm.showPopoverClinica = false
      vm.$refs.clinica.focus()
      vm.actualizar()
    },
    cerrarClinica (o) {
      var vm            = this
      vm.showPopoverClinica = false
      vm.$refs.clinica.focus()
    },
    //* Popover clinica
    // Popover Doctor
    seleccionarDoctor (o) {
      var vm            = this
      vm.idDoctor           = o._id ? o._id + '' : ''
      vm.nombreDoctor       = o.nombre
      // Setear clinica default
      vm.showPopoverDoctor  = false
      vm.$refs.doctor.focus()
      vm.actualizar()
    },
    cerrarDoctor (o) {
      var vm            = this
      vm.showPopoverDoctor = false
      vm.$refs.doctor.focus()
    },
    //* Popover Doctor
    // Popover Tecnico
    seleccionarTecnico (o) {
      var vm            = this
      vm.idTecnico           = o._id ? o._id + '' : ''
      vm.nombreTecnico       = o.nombre
      vm.showPopoverTecnico  = false
      vm.$refs.tecnico.focus()
      vm.actualizar()
    },
    cerrarTecnico (o) {
      var vm            = this
      vm.showPopoverTecnico = false
      vm.$refs.tecnico.focus()
    },
    //* Popover Tecnico
    // Popover Enfermera
    seleccionarEnfermera (o) {
      var vm            = this
      vm.idEnfermera           = o._id ? o._id + '' : ''
      vm.nombreEnfermera       = o.nombre
      vm.showPopoverEnfermera  = false
      vm.$refs.enfermera.focus()
      vm.actualizar()
    },
    cerrarEnfermera (o) {
      var vm            = this
      vm.showPopoverEnfermera = false
      vm.$refs.enfermera.focus()
    },
    //* Popover Enfermera
    // Popover Tipo Cirugia
    seleccionarTipoCirugia (o) {
      var vm            = this
      vm.idTipoCirugia           = o._id ? o._id + '' : ''
      vm.descripcionTipoCirugia       = o.descripcion
      vm.showPopoverTipoCirugia  = false
      vm.$refs.tipoCirugia.focus()
      vm.actualizar()
    },
    cerrarTipoCirugia (o) {
      var vm            = this
      vm.showPopoverTipoCirugia = false
      vm.$refs.tipoCirugia.focus()
    },
    //* Popover TipoCirugia
    actualizar () {
      var vm = this
      vm.fetch()
      // vm.isLoadingActualizar = true
      // if (vm.fechaTerminadoDesde || vm.fechaTerminadoHasta) {
      //   if (!vm.fechaTerminadoDesde) vm.fechaTerminadoDesde = vm.fechaTerminadoHasta
      //   if (!vm.fechaTerminadoHasta) vm.fechaTerminadoHasta = vm.fechaTerminadoDesde
      // }

      // vm.$nextTick(function () {
      //   vm.$refs.tasklista.fetch()
      //   setTimeout(function () { vm.isLoadingActualizar = false; }, 500);
      // })
    },
    downloadExcel () {
      console.log(this.isExcel)
      var vm = this
      var url = '/cirugia/excel'
      vm.isLoadingExcel = true

      var obj = {}
      obj.idClinica     = vm.idClinica
      obj.idDoctor      = vm.idDoctor
      obj.idTecnico     = vm.idTecnico
      obj.idEnfermera   = vm.idEnfermera
      obj.idTipoCirugia = vm.idTipoCirugia
      obj.tipoCobro     = vm.tipoCobro
      obj.fechaDesde    = vm.fechaDesde
      obj.fechaHasta    = vm.fechaHasta

      obj.sortByName    = vm.sortByName
      obj.sortByType    = vm.sortByType
      obj.skip          = 0

      apiGetExcel(vm, url, obj, function (data) {
        console.log('data:', data)
        var a = document.createElement('a');
        a.style = 'display: none';
        document.body.appendChild(a);

        var blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,'})
        var url = window.URL.createObjectURL(blob)

        a.href = url;
        a.download = 'cirugia_excel_' + '_' + ((new Date()).getTime()) + '.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      }, function (err) {
        notify(vm, 'error', 'Error', err.message)
      }, function () {
        vm.isLoadingExcel = false
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .is-active
    color #2e7bda
    i
      color #2e7bda
    border-color #2e7bda
</style>



// WEBPACK FOOTER //
// v_cirugia_list.vue?b78f68f4